var amdi18n={"__root":{"COMING_SOON":"Coming Soon!","RELATED_ARTISTS":"Related Artists","SINGLES":"Singles","COMPILATIONS":"Compilations","ALBUMS":"Albums","APPEARS_ON":"Appears On","TOP_SONGS":"Top Songs","YOUTUBE_VIDEOS":"Youtube Videos","SHORTCAST":"Content"},"__fr":{"COMING_SOON":"Arrive bientôt!","RELATED_ARTISTS":"Artistes apparentés","SINGLES":"Singles","COMPILATIONS":"Compilations","ALBUMS":"Albums","APPEARS_ON":"Apparaît sur","TOP_SONGS":"Top chansons","YOUTUBE_VIDEOS":"Vidéos youtube","SHORTCAST":"Contenu"},"__en":{"COMING_SOON":"Coming Soon!","RELATED_ARTISTS":"Related Artists","SINGLES":"Singles","COMPILATIONS":"Compilations","ALBUMS":"Albums","APPEARS_ON":"Appears On","TOP_SONGS":"Top Songs","YOUTUBE_VIDEOS":"Youtube Videos","SHORTCAST":"Content"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;